module.exports = __webpack_public_path__ + "static/img/logo-domain@2x.85e92ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/domain-custom/base/logo-domain@2x.png
// module id = 640
// module chunks = 1